// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"node_modules_sitebase_pre-integrated-features_es_deposit-common_QuickDeposit_index_js-node_mo-9d40f4":"0db126e9f113a3ef0037","node_modules_sitebase_pre-integrated-features_es_deposit-common_StandardDeposit_index_js-node-7474ce":"907ba34b188600c78762"}[chunkId] + ".css";
};